import { createSelector } from 'reselect';
import type { RootState } from 'typesafe-actions';

import type { NotificationState } from './reducer';
export const getNotification = (state: RootState) => state.notification;

export const getItem = createSelector(getNotification, (state: NotificationState) => state.item);
